/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const addNonCompliantListingRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc',
  rpcName: 'addNonCompliantListing',
  auth: 'app',
  fingerprint: 'h3ymYisdA7mOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const addNonCompliantListingsBatchRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc',
  rpcName: 'addNonCompliantListingsBatch',
  auth: 'app',
  fingerprint: '6N2HYFByt1GOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const removeNonCompliantListingRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc',
  rpcName: 'removeNonCompliantListing',
  auth: 'app',
  fingerprint: 'T1pHWO1tCHuOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const removeNonCompliantListingsBatchRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc',
  rpcName: 'removeNonCompliantListingsBatch',
  auth: 'app',
  fingerprint: '5y0JJBRbqFaOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSecureInstallComplianceRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc',
  rpcName: 'getSecureInstallCompliance',
  auth: 'app',
  fingerprint: 'W57sXM6zsJyu1vdYHPPzlZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};